import React from "react";
import {Separator} from "@vkontakte/vkui";
import Countdown from "../../components/Countdown/Countdown";
import {timeToMidnight} from "../../utils/time";
import {numberWordSuffix} from "../../utils/word";

const BUTTON_CLASSES = "app-btn-primary cursor-pointer";

const BUY_LIVES_BUTTON_CLASSES = {
    enabled: "cursor-pointer app-btn-primary",
    disabled: "cursor-default bg-gray-300 hover:bg-gray-300 border-gray-400/20 text-gray-500",
};

// Обрабатывает нажатия Enter/Space для кастомной кнопки покупки
const handleBuyButtonKeyDown = (event, canBuy, onBuy, onCannotBuy) => {
    if (event.key !== "Enter" && event.key !== " ") {
        return;
    }
    event.preventDefault();
    if (canBuy) {
        onBuy();
        return;
    }
    onCannotBuy();
};

// AttemptsPanel показывает блок старта игры или покупки жизней, опционально с таймером
const AttemptsPanel = ({
                           dailyAttemptPrice,
                           canBuy,
                           onBuy,
                           availableAttempts,
                           onStart,
                           title,
                           description,
                           withCountdown,
                           onCannotBuy,
                           isLight = false,
                       }) => {
    const panelClasses = isLight
        ? "flex flex-col mx-auto pt-3 py-4 items-center justify-center w-full bg-gray-200 border border-gray-300/60 rounded-xl px-4 gap-3 shadow-sm"
        : "flex flex-col mx-auto pt-3 py-4 items-center justify-center w-full bg-gray-100 rounded-xl px-4 gap-3";
    const subtitleClass = isLight ? "text-sm text-gray-700 text-center" : "text-sm text-gray-500 text-center";
    const attemptsClass = isLight ? "text-xs text-gray-800" : "text-xs text-gray-700";
    const titleClass = isLight ? "text-sm text-gray-800 text-center" : "text-sm text-gray-700 text-center";
    const descriptionClass = isLight ? "text-xs text-gray-700 text-center" : "text-xs text-gray-500 text-center";

    return (
        <div className={panelClasses}>
            {withCountdown && (
                <>
                    <Countdown date={timeToMidnight()}/>
                    <Separator/>
                </>
            )}
            {availableAttempts > 0 ? (
                <div className="flex flex-col items-center gap-2 w-full max-w-sm">
                    <Button
                        size="s"
                        mode="primary"
                        stretched
                        className={`${BUTTON_CLASSES}`}
                        onClick={onStart}
                    >
                        Начать новую игру
                    </Button>
                    <div className={subtitleClass}>
                        Начните новую игру и попробуйте улучшить результат 😉
                    </div>
                    <div className={attemptsClass}>
                        {numberWordSuffix(availableAttempts, ["Осталась", "Осталось", "Осталось"])} {availableAttempts} {numberWordSuffix(availableAttempts, ["жизнь", "жизни", "жизней"])}
                    </div>
                </div>
            ) : (
                <div className="flex flex-col items-center gap-2 w-full max-w-sm">
                    <div
                        role="button"
                        tabIndex={0}
                        aria-disabled={!canBuy}
                        className={
                            "border-solid border-2 rounded-lg px-3 py-1 w-full text-sm " +
                            (canBuy ? BUY_LIVES_BUTTON_CLASSES.enabled : BUY_LIVES_BUTTON_CLASSES.disabled)
                        }
                        onClick={canBuy ? onBuy : onCannotBuy}
                        onKeyDown={(event) => handleBuyButtonKeyDown(event, canBuy, onBuy, onCannotBuy)}
                    >
                        <div className="flex flex-col items-center justify-center text-center leading-5">
                            <div className="text-sm">Пополнить жизни</div>
                            <div className="text-xs">
                                3 <span className="leading-none">❤️</span> за {dailyAttemptPrice} {numberWordSuffix(dailyAttemptPrice, ["монету", "монеты", "монет"])}
                            </div>
                        </div>
                    </div>
                    <div className={titleClass}>{title}</div>
                    <div className={descriptionClass}>{description}</div>
                </div>
            )}
        </div>
    );
};

export default AttemptsPanel;
